import * as React from 'react'
import { SVGProps } from 'react'
const SvgShirt = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 454 410" {...props}>
    <mask id="a" fill="#fff">
      <path d="M76 410v-36h301v36H76z" />
    </mask>
    <path
      d="M76 410H59.4v16.6H76V410zm301 0v16.6h16.6V410H377zm-284.4 0v-36H59.4v36h33.2zm267.8-36v36h33.2v-36h-33.2zm16.6 19.4H76v33.2h301v-33.2z"
      fill="#4E4E4E"
      mask="url(#a)"
    />
    <path
      d="M368.981 374V163l50.852 10.5L444 62.5 310.123 11C301.228 38.667 277.751 93.4 227 91M84.5 374V163l-50.333 10.5L10 62.5 143.877 11c8.895 27.667 32.372 82.4 83.123 80M85.5 364H368"
      stroke="#4E4E4E"
      strokeWidth={16.6}
    />
    <path fill="#4E4E4E" d="M229 83h-4v9h4z" />
  </svg>
)
export default SvgShirt
